import React, { useEffect } from 'react';

import i18n from 'i18n';
import moment from 'moment';

import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import ContentLoader from '../../ContentLoader';
import CmtImage from '../../../../@coremat/CmtImage';
import AuthWrapper from './AuthWrapper';

import { makeStyles } from '@mui/styles';
import { alpha, Box, Hidden, Typography } from '@mui/material';

import { loginWithSaml2Token } from 'redux/Account/AccountAction';
import { getQueryStrings } from 'services/Utilities/Utilities';
import { homePage, IsImpersonationMode, localeStorageLanguageKey } from 'config/config';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  authThumb: {
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    padding: 0,
    width: '100%',
    borderTopRightRadius: '4px',
    borderBottomRightRadius: '4px',
    [theme.breakpoints.up('md')]: {
      width: '50%',
      order: 2,
      objectFit: 'cover',
    },
  },
  maxWidth50: {
    width: '50%',
  },
  authContent: {
    padding: 30,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: props => (props.variant === 'default' ? '50%' : '100%'),
      order: 1,
    },
    [theme.breakpoints.up('xl')]: {
      padding: 50,
    },
  },
  imageLogoAndLanguage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleRoot: {
    marginBottom: 14,
    color: `${theme.palette.secondary.main}`,
    fontSize: '1.75rem',
  },
}));
//variant = 'default', 'standard'
const SignedIn = ({ variant = 'default', wrapperVariant = 'default' }) => {
  const classes = useStyles({ variant });
  const { t } = useTranslation();

  const accountReducer = useSelector(state => state.AccountReducer);

  let hist = useHistory();
  const dispatch = useDispatch();

  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  useEffect(() => {
    if (!token || accountReducer?.isLoggedIn) {
      return;
    }

    dispatch(loginWithSaml2Token(token))
      .then(user => {
        var preferredLanguage = user.person?.preferredLanguage;

        if (preferredLanguage && i18n.language !== preferredLanguage) {
          localStorage.setItem(localeStorageLanguageKey, preferredLanguage);
          i18n.changeLanguage(preferredLanguage);
          if (preferredLanguage === 'fr') moment.locale('fr-CA');
          else moment.locale('en-CA');
        }
      })
      .catch(() => {
        hist.push('/signin?ssoError=1');
      });
  }, [accountReducer?.isLoggedIn, dispatch, hist, token]);

  useEffect(() => {
    if (accountReducer?.isLoggedIn) {
      let queryStrings = getQueryStrings();
      let returnUrl = queryStrings['returnUrl'];
      let url = `${returnUrl || homePage}`;

      if (IsImpersonationMode) {
        hist.push(`/signin?employeeSelector=1&returnUrl=${url}`);
        return;
      }

      if (accountReducer?.isDemo) {
        setTimeout(() => {
          hist.push(url);
        }, 3000);
      } else {
        hist.push(url);
      }
    }
  }, [accountReducer?.isDemo, accountReducer?.isLoggedIn, hist]);

  return (
    <AuthWrapper variant={wrapperVariant}>
      <Hidden mdDown>
        <CmtImage className={classes.authThumb} src={'/images/main-iwd-lanidingartboard-3.avif'} />
      </Hidden>
      <Hidden mdUp>
        <CmtImage src={'/images/main-iwd-lanidingartboard-3.avif'} />
      </Hidden>
      <Box className={classes.authContent}>
        <Box xs={12} className={classes.imageLogoAndLanguage}>
          <CmtImage className={classes.maxWidth50} src={'/images/brp-logo.png'} />
        </Box>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography component="div" variant="h1" className={classes.titleRoot}>
            {t('logging_in')}
          </Typography>
        </Box>

        <ContentLoader />
      </Box>
    </AuthWrapper>
  );
};

export default SignedIn;
